import { getGtmData } from ".";
import { getBackButtonTitleSchemeListPage } from "../components/modules/mutualFund/explorePage/util";
import { EXPLORE_SCHEMES_USER_FLOW } from "../constants/ExplorePage";
import { replaceEmptySpaceWithHyphen } from "../utils/common";

export interface SchemeListDataGTM {
  fundCategory?: string;
  fundSubCategory?: string;
  actionType?: string; // Can have either Home or Landing Screen as value
  invIdeaScheme?: string; // For Inv ideas page. Ex- Invest in bluechip funds
  schemeName?: string; // Only used for Invest button click
}

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// For on loading of scheme list page for all mutual funds, inv ideas, save tax and choose goals with sip 
export const getPageNameForSchemeListGTM = (userFlow: string, data: SchemeListDataGTM) => {
  const { fundCategory, fundSubCategory, actionType, invIdeaScheme } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${fundCategory.toLowerCase()}-funds`;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `explore-investment-ideas/${replaceEmptySpaceWithHyphen(invIdeaScheme, true)}/${actionType.toLowerCase()}`;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `save-tax`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `plan-your-goals-with-sip/${replaceEmptySpaceWithHyphen(getGtmData('cd73'), true)}/${replaceEmptySpaceWithHyphen(fundSubCategory, true)}/schemes`
  }
}

export const getPageTitleForDurationSelectGTM = (userFlow: string, fundCategory, subCategory) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `save tax elss`
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${fundCategory ? fundCategory + " Funds" : "Explore"}`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `Explore Investment Ideas`
  }
}

export const getPageLabelForMutualFundHomeCardClick = (userFlow: string) => {
  switch(userFlow.toUpperCase()) {
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `save tax elss`
    default: 
      return userFlow;
  }
}

export const getPageTitleForSchemePageLoadListGTM = (userFlow: string, data?: SchemeListDataGTM) => {
  const { fundCategory, fundSubCategory, actionType, invIdeaScheme } = data;

  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${getBackButtonTitleSchemeListPage(null, fundCategory)}`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `Explore Investment Ideas - ${invIdeaScheme} - ${actionType}`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `Save Tax`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `Plan Your Goals with SIP - ${getGtmData('cd73')} - ${fundSubCategory} - Schemes`
  }
}

// For Back Click Handler
export const getLabelForBackClickGTM = (userFlow: string, data: SchemeListDataGTM) => {
  const { fundCategory, invIdeaScheme } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${getBackButtonTitleSchemeListPage(null, fundCategory)}`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `Explore Investment Ideas - ${invIdeaScheme}`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `save tax elss`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `Plan Your Goals with SIP - ${getGtmData('cd73')} - Schemes`
  }
}
// For Transaction Success
export const getTitleForTransactionSuccess = (userFlow: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `Explore`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `Investment Ideas`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `Save Tax`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `Insta SIP`
  }
}

// For Transaction Success
export const getPageLabelForTransactionSuccess = (userFlow: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `Explore`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `investment-ideas`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `save-tax`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `insta-sip`
  }
}

// For click of any sub category present in the filter  

export const getPageNameSchemeFilterSelectGTM = (userFlow: string, data: SchemeListDataGTM) => {
  const { fundCategory, fundSubCategory } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${replaceEmptySpaceWithHyphen(getBackButtonTitleSchemeListPage(null, fundCategory), true)}/${replaceEmptySpaceWithHyphen(fundSubCategory, true)}`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `plan-your-goals-with-sip/${replaceEmptySpaceWithHyphen(getGtmData('cd73'), true)}/${replaceEmptySpaceWithHyphen(fundSubCategory, true)}/schemes`
  }
}

// for both title and label value format is same so using only one function for both
export const getTitleAndLabelOnSchemeSelectFilter = (userFlow: string, data: SchemeListDataGTM) => {
  const { fundCategory ,fundSubCategory } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${getBackButtonTitleSchemeListPage(null, fundCategory)} - ${fundSubCategory}`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `Plan Your Goals with SIP - ${getGtmData('cd73')} - ${fundSubCategory} - Schemes`
  }
}

// For Axis select toggle click 
export const getPageNameAxisSelectToggleGTM = (userFlow: string, data: SchemeListDataGTM) => {
  const { fundCategory, invIdeaScheme } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      // converts Equity to equity-funds
      return `${replaceEmptySpaceWithHyphen(getBackButtonTitleSchemeListPage(null, fundCategory), true)}`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `explore-investment-ideas/${replaceEmptySpaceWithHyphen(invIdeaScheme, true)}`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return 'save-tax-elss';
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `plan-your-goals-with-sip/${replaceEmptySpaceWithHyphen(getGtmData('cd73'), true)}`
  }
}

export const getTitleAndLabelOnAxisSelectToggleGTM = (userFlow: string, data: SchemeListDataGTM) => {
  const { fundCategory, invIdeaScheme } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${getBackButtonTitleSchemeListPage(null, fundCategory)}`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      return `Explore Investment Ideas - ${invIdeaScheme}`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return 'save tax elss'
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `Plan Your Goals with SIP - ${getGtmData('cd73')}`
  }
}

// Get label for On click of invest button 
export const getLabelForInvestClickGTM = (userFlow: string, data: SchemeListDataGTM) => {
  const { invIdeaScheme, schemeName } = data;
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      return `${schemeName}`
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS: 
      return `Explore Investment Ideas - ${invIdeaScheme} - ${schemeName}`
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      return `${schemeName}`
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      return `${getGtmData('cd73')} - ${schemeName}`
  }
}